import { render } from "./App.vue?vue&type=template&id=1175e4cf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1175e4cf&lang=css"

import exportComponent from "/home/jiaxf/prod/fltrp-dams-admin-ui/builds/VjEGYzGkB/0/unilearn/unilearn-web-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__